import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  typography: {
    allVariants: {
      fontFamily: ['Raleway','serif'],
    },
  },
  palette: {
    primary: {
      main: '#B79266',
      contrastText: '#FFFFFF',
    },
    secondary: {
      light: '#F6F1EB',
      main: '#B79266',
      dark: '#8C6A42',
      contrastText: '#FFFFFF',
    },
  },
  components: {
    // mp-react-components ships a global, unscoped `button.MuiButton-root` rule
    // (color/border: #B79266) meant for its own legacy toolbar buttons. Its
    // element+class specificity beats MUI's own generated contained-button
    // classes, so contained primary/secondary buttons render with invisible
    // (same-color-as-background) text unless forced back with !important here.
    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          color: '#FFFFFF !important',
        },
        containedSecondary: {
          color: '#FFFFFF !important',
        },
      },
    },
  },
});

export default theme;
